import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";

const initialState = {
  sidebar: {
    sidebarOpen: true,
    sidebarCustomerSupportOpen: false,
    sidebarMarketingOpen: false,
    sidebarShipOpen: false,
    sidebarPlannerOpen: false,
    sidebarTruckOpen: false,
    sidebarTrainOpen: false,
    sidebarContainerRepairOpen: false,
    sidebarFinancialOpen: false,
    sidebarSetttingOpen: false,
  },
};

export const globalSlice = createSlice({
  name: "global",
  initialState: initialState,
  reducers: {
    toggleSidebar: (state, action) => {
      state.sidebar.sidebarOpen = action.payload;
    },
    toggleCustomerSupportSidebar: (state, action) => {
      state.sidebar.sidebarCustomerSupportOpen = action.payload;
    },
    toggleMarketingSidebar: (state, action) => {
      state.sidebar.sidebarMarketingOpen = action.payload;
    },
    toggleShipSidebar: (state, action) => {
      state.sidebar.sidebarShipOpen = action.payload;
    },
    togglePlannerSidebar: (state, action) => {
      state.sidebar.sidebarPlannerOpen = action.payload;
    },
    toggleTruckSidebar: (state, action) => {
      state.sidebar.sidebarTruckOpen = action.payload;
    },
    toggleTrainSidebar: (state, action) => {
      state.sidebar.sidebarTrainOpen = action.payload;
    },
    toggleContainerRepairSidebar: (state, action) => {
      state.sidebar.sidebarContainerRepairOpen = action.payload;
    },
    toggleFinancialSidebar: (state, action) => {
      state.sidebar.sidebarFinancialOpen = action.payload;
    },
    toggleSettingSidebar: (state, action) => {
      state.sidebar.sidebarSetttingOpen = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  toggleSidebar,
  toggleCustomerSupportSidebar,
  toggleMarketingSidebar,
  toggleShipSidebar,
  togglePlannerSidebar,
  toggleTruckSidebar,
  toggleTrainSidebar,
  toggleContainerRepairSidebar,
  toggleFinancialSidebar,
  toggleSettingSidebar,
} = globalSlice.actions;

export const loginUser = createAsyncThunk(
  "users/login",
  async ({ username, password }, thunkAPI) => {
    try {
      const response = await api.post("api/auth/login", {
        username,
        password,
      });
      if (response.meta.status === true) {

        localStorage.setItem("token", response.data.accessToken);
        localStorage.setItem("EmpId", response.data.userID);
        const getProffile = async () => {
          const res = await (api.get('api/auth/profile',
            {
              // headers: {
              //   'Authorization': `Bearer ${response.data.accessToken}`
              // }
            }))
          // if (res.data.status === true) {
            localStorage.setItem("RoleID", res.data.RoleId);
            localStorage.setItem("userName", res.data.username);
          //   }
          }
          getProffile()
          return response
        } else {
          console.log(thunkAPI.rejectWithValue(response));
        return thunkAPI.rejectWithValue(response);
      }
    } catch (e) {
      console.log("Error", e.response.data);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const RoleCheck = createAsyncThunk(
  "users/checkRole",
  async (data, thunkAPI) => {
    return data;
    // try {
    //   const response = await api.post("api/checkRole", {
    //     username,
    //     password,
    //   });
    //   if (response.data.code === 200) {
    //     localStorage.setItem("token", response.data.token);
    //     localStorage.setItem("userName", response.data.data.EmpName);
    //     localStorage.setItem("EmpId", response.data.data.EmpId);
    //     localStorage.setItem("RoleID", response.data.data.RoleId);
    //     return response;
    //   } else {
    //     console.log(thunkAPI.rejectWithValue(response));
    //     return thunkAPI.rejectWithValue(response);
    //   }
    // } catch (e) {
    //   console.log("Error", e.response.data);
    //   thunkAPI.rejectWithValue(e.response.data);
    // }
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState: {
    username: "",
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isFetching = false;

      return state;
    },
  },
  extraReducers: {
    [loginUser.fulfilled]: (state, { payload }) => {
      state.username = payload
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [loginUser.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.data;
    },
    [loginUser.pending]: (state) => {
      state.isFetching = true;
    },
  },
});

export const RoleMenuSlice = createSlice({
  name: "RoleMenuActive",
  initialState: {
    List: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isFetching = false;

      return state;
    },
  },
  extraReducers: {
    [RoleCheck.fulfilled]: (state, { payload }) => {
      state.List = payload;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [RoleCheck.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.data;
    },
    [RoleCheck.pending]: (state) => {
      state.isFetching = true;
    },
  },
});

export default globalSlice.reducer;

export const { clearState } = userSlice.actions;

export const userSelector = (state) => state.user;
